import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { Subtitle, Title } from "~/components/ui/Typography";
type AuthPanelProps = {
  title: string;
  subtitle: ReactNode;
  banner?: ReactNode;
  children: ReactNode;
};
export function AuthPanel(t0) {
  const $ = _c(11);
  const {
    title,
    subtitle,
    banner,
    children
  } = t0;
  let t1;
  if ($[0] !== banner) {
    t1 = banner ? <div className="mb-3 sm:mb-4">{banner}</div> : null;
    $[0] = banner;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <Title as="h1" size="section" className="mb-1 text-[clamp(24px,6vw,40px)]">{title}</Title>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== subtitle) {
    t3 = <Subtitle className="mb-4 sm:mb-6">{subtitle}</Subtitle>;
    $[4] = subtitle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children || $[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <div className="w-full max-w-[380px] sm:max-w-[400px]">{t1}{t2}{t3}{children}</div>;
    $[6] = children;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}